// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { Map } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer.js';
import { CANCEL, SHOW_FORM, SUBMIT } from './action-types.js';

const initialState = Map({
  active: false,
  title: '',
  config: {}
});

function hide(state) {
  return state.set('active', false);
}

export default simpleReducer(initialState, {
  [SHOW_FORM](_state, { payload }) {
    return Map({
      active: true,
      config: payload.config,
      title: payload.title,
      formName: payload.formName,
      instructions: payload.instructions,
      submitLabel: payload.submitLabel
    });
  },
  [CANCEL]: hide,
  [SUBMIT]: hide
});
